import React from 'react';
import { Segment, Header, Icon, Grid, Card, Breadcrumb, Image, Modal, Button } from 'semantic-ui-react';

import moment from 'moment';
import './RestrictedSBRDetails.less';

import { getSingleBuyerRequestDetails, getSbrBidsHistory, getSingleBuyerRequestDetailsByToken } from '../../services/Project';

import PhotoCarousel from '../../components/PhotoCarousel/PhotoCarousel';
import TimeCountDown from '../../components/TimeCountDown/TimeCountDown';
import BidHistory from '../../components/BidHistory/BidHistory';
import RequestInfo from '../../components/RequestInfo/RequestInfo';
import { priceDisplay } from '../../helpers/price';
import PhotoCarouselNew from '../../components/PhotoCarouselNew/PhotoCarouselNew';
import RequestInfoNew from '../../components/RequestInfoNew/RequestInfoNew';
import DisplayDistanceNew from '../../components/DisplayDistanceNew/DisplayDistanceNew';
import _ from 'lodash';
import DisplayPriceConfirmation from '../../components/DisplayPriceConfirmation/DisplayPriceConfirmation';
import calendarIicon from '../../assets/images/newui/calendar-icon.svg'

class RestrictedSBRDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: { bid: {}, service: {}, sbr: {}, images: [], buyer: {} },
            openedImageIndex: -1,
            renderUI: false,
            errorMessageClient: [],
            jobNotAvailable: false
        }
        this.sbrId = 0;
    }

    async componentDidMount() {
        this.sbrToken = this.props.match.params.requestToken;
        const details = await getSingleBuyerRequestDetailsByToken(this.sbrToken);
        if(details.resStatus == 200){
            await this.setState({
                details: details && details.data || { bid: {}, service: {}, sbr: {}, images: [], buyer: {} },
                //bidsHistory: bidsHistory && bidsHistory.data || []
                renderUI: true
            });
        }
        else{
            // this.props.history.push('/');
            this.setState({jobNotAvailable : true})
        }
        //let bidsHistory;
        if (details  && details.data && details.data.bid && details.data.bid && details.data.bid.sellerBid) {
            //bidsHistory = await getSbrBidsHistory(this.sbrId);
        }


        
    }

    render() {
        {/*const {/*bidsHistory, details } = this.state;
        const { bid, service, sbr, images } = details;
        return (
            this.state.renderUI && <div className="DashboardContainer animated fadeInRight">
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h3">
                            <Header.Content>
                                <Icon name='info circle' size='small' />
                                Request Details
                            </Header.Content>
                        </Header>
                    </Segment>
                    
                </Segment.Group>
                <Grid celled>
                    <Grid.Row>
                        <Grid.Column>
                            <Card fluid>
                                <Card.Content>
                                    <Grid>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Service:</strong></Grid.Column>
                                            <Grid.Column width="10">{service && service.name || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Initiated:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr && sbr.initiated && moment(sbr.initiated).format('lll') || null}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Request Info:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr.quickInfo || null}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Buyer Notes:</strong></Grid.Column>
                                            <Grid.Column width="10">{sbr && sbr.buyerNotes || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Expires:</strong></Grid.Column>
                                            <Grid.Column width="10"><TimeCountDown date={sbr && sbr.expiry} /></Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Total Bids:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.totalBids}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Current:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.minBid && priceDisplay(bid.minBid)}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="2"><strong>Buyer Distance:</strong></Grid.Column>
                                            <Grid.Column width="10">{bid && bid.buyerDistance || 'N/A'}</Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                                <PhotoCarousel images={images} />
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                                <RequestInfo title="Client Submitted Info" serviceRequestInfo={sbr.serviceFormData} />
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row columns={4}>
                                            <Grid.Column width="2"></Grid.Column>
                                            <Grid.Column width="12">
                                            </Grid.Column>
                                            <Grid.Column width="2"></Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    
                                    {/*<BidHistory bidHistory={bidsHistory} userHas2PlaceBid={bid && !bid.sellerBid} />}

                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );*/}
        const { details, bidsHistory } = this.state;
    const { bid, service, sbr, images, seller, buyer } = details;
    let postProcessingaAvailable = sbr.postProcessing && !_.isEmpty(sbr.postProcessing) && sbr.postProcessing.distance && !_.isEmpty(sbr.postProcessing.distance) ? true : false;
        return (
            this.state.jobNotAvailable ? <div className="job-not-available-container">
                <div>
                   <img src={calendarIicon}></img>
                   <h1>
                        This Job is no longer available.
                    </h1>
                </div>
            </div> : 
            <div onClick={this.handleClick} className="restricted-sbr-details-container animated fadeInRight">
              
              <Grid >
                <Grid.Row className={"top-heading-row"}>
                  <Grid.Column className={"top-heading-col"}>
                    
                    <Grid.Row className={"header-row"}>
                      <Grid.Column className={"header-column"}>
                        <div className={"header-container"}>
                          <div className={"header"}>
                            {service?.name}
                            
                          </div>
                        </div>
                      </Grid.Column>
                      
                    </Grid.Row>
                  </Grid.Column>
                </Grid.Row>
      
                <Grid.Row className={"content-panel-row"}>
                  <Grid.Column>
                    
                      <Grid style={{ backgroundColor: "white" }}>
                        <Grid.Row style={{ paddingBottom: '0px' }}>
                          <Grid.Column computer={16} mobile={16}>
                            <div className="sbr-details-segment">
                            
                            { 
                            !_.isEmpty(sbr) && 
                            <Grid className={`sbr-confirmation-price-grid ${!postProcessingaAvailable ? "sbr-details-grid with-post-processing" : ""}`}>
                                <Grid.Row className={"sbr-details-row"}>
                                    <Grid.Column computer={16} mobile={16} className="sbr-details-column">

                                        <div className={"outer-wrapper"}>
                                            <div className={"sbr-price-confirmation-container"}>
                                                {<DisplayPriceConfirmation service={service} sbr={sbr} token={this.sbrToken} buyer={buyer}></DisplayPriceConfirmation>}
                                            </div>
                                        </div>

                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            }
                            {postProcessingaAvailable &&<Grid className={`sbr-details-grid ${postProcessingaAvailable ? "with-post-processing" : ""}`}>
                                 <Grid.Row className={"sbr-details-row"}>
                                    <Grid.Column computer={16} mobile={16} className={"sbr-details-column"}>

                                        <div className={"outer-wrapper"}>
                                            <div className={"sbr-details-distance-container"}>
                                                {sbr && <DisplayDistanceNew showViewLink={true} sbr={sbr} ></DisplayDistanceNew>}

                                            </div>
                                        </div>
                                        {
                                            window.innerWidth >= 1024 && this.state.errorMessageClient.length > 0 &&
                                            <div className={"client-error-msg-container"}>
                                                {this.state.errorMessageClient}
                                            </div>
                                        }

                                    </Grid.Column>
                                  
                                </Grid.Row>
                              </Grid>}
                            </div>
                          </Grid.Column>
                          
                        </Grid.Row>
      
      
                        <Grid.Row columns={1} className={"content-container-row"} style={!postProcessingaAvailable ? { paddingTop: '0px'} : {}}>
                          
                          <Grid.Column computer={16} mobile={16} tablet={16} style={{ paddingRight: '0px' }}>
                            <Grid.Row columns={1} style={{ paddingTop: "57px" }}>
                              <Grid.Column width="16">
                                <div className="request-info-container">
                                  <RequestInfoNew onMoreInfoClick={this.onMoreInfoClick} isUnAuthorized={this.props.isUnAuthorized} title="Details" buyerMobileNo={sbr.cellPhone} buyerName={sbr.buyerName} serviceRequestInfo={sbr.serviceFormData} sellerDetail={seller} hideMoreInfo={true} />
                                </div>
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                              <Grid.Column width="16">
                                <div className="photos-container">
                                  <PhotoCarouselNew images={images} />
                                </div>
                              </Grid.Column>
                            </Grid.Row>
                        </Grid.Column>
                          
                        </Grid.Row>
                      </Grid>
                    
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div >
          )
    }
}

export default RestrictedSBRDetails;